import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const tenantEmailConfigEntity: Entity = {
  model: model,
  repository: repository,
}

export default tenantEmailConfigEntity
